<style scoped lang="scss">
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/material/inventory/pageOneLevel"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->

    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongyingshangbianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangdizhi')" required>
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxiren')">
            <el-input v-model="yt.editObj.contacts"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxifangshi')">
            <el-input v-model="yt.editObj.contactsInfo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('youxiang')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/supplier/create')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongyingshangbianma')" required>
            <el-input v-model="yt.editObj.code" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangdizhi')" required>
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxiren')">
            <el-input v-model="yt.editObj.contacts"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxifangshi')">
            <el-input v-model="yt.editObj.contactsInfo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('youxiang')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/supplier/update')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>

    </el-dialog>
    <import_excel :show.sync="show"/>
  </div>
</template>
<script type="text/javascript">
import import_excel from '@@/pages/web/wms/material_inventory/import_excel'

export default {
  components: {
    import_excel,
  },
  name: 'wms_monitor_store_chart_material_inventory_list',
  data() {
    return {
      show: false,
      productType: [],
      warehouseList: [],
      columns: [{
        label: 'wuliaobianma',
        prop: 'material.code',
        width: 150,
      },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 150,
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150,
        },
        {
          label: 'kucunshuliang',
          prop: 'total',
        },
        {
          label: 'kucundanwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE',
          // width: 150,
        }
      ],
    };

  },
  props: {
    equipment: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },

  created() {
    setTimeout(() => {
      this.yt.conditions = {
        //表格默认按照创建时间降序排序。
        orderBy: 'createTime desc',
        warehouseIds: this.equipment.warehouseId
      }
      this.yt.get(1);
      this.getProductType();
      this.utils.event_hub.$on('MATERIAL_INVENTORY_LIST', () => {
        this.yt.get(1);
      })
    }, 300)
  },
  methods: {

    // 请求查询客户数据字典中的产品分类
    async getProductType() {
      let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
        params: {
          code: "GYLXCPFL",
        }
      })
      this.productType = response.data
      console.log(this.productType)
    },
  },
};
</script>